import { isPlatformBrowser } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { Resolve, RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { filter, switchMap, take } from 'rxjs/operators';
import { AppInitializationService } from 'src/app/core/services/app-initializer.service';
import { RequestsToVerifyService } from 'src/app/core/services/requests-to-verify.service';
import { RequestToVerifySummary } from 'src/app/shared/interfaces/request-to-verify-summary';

@Injectable({
  providedIn: 'root'
})
export class RequestToVerifySummaryResolver implements Resolve<RequestToVerifySummary>
{
  constructor(
    private requestsToVerifyService: RequestsToVerifyService,
    private appInitializationService: AppInitializationService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {}

  resolve(route: ActivatedRouteSnapshot, _: RouterStateSnapshot): Observable<RequestToVerifySummary> {

    if (!isPlatformBrowser(this.platformId)) {
      return of({} as RequestToVerifySummary); // Si no es navegador, permitir la navegación (en SSR no bloquea)
    }

    return this.appInitializationService.isInitialized().pipe(
          filter(initialized => initialized),  // Esperar hasta que sea `true`
          take(1),  // Tomar solo el primer valor `true`
          switchMap(() => {
    
            const idVerificacion: string = route.params.idVerificacion;

            return this.requestsToVerifyService.getSummaryData(idVerificacion);
          })
        );
  }
}
